import { DataModel } from '../../dto/data-model.js';
import { PayloadType } from './payload-type.js';

export abstract class Payload extends DataModel {
  abstract get type(): PayloadType;
}
